import styled from "@emotion/styled";

export const App = styled.div`
  display: flex;
  flex-direction: column;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
`;
